import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/page.jsx");
